module.exports = __webpack_public_path__ + "img/car-battery-opacity.004f50c2.svg";